<template>
  <div class="title">
    <h2>{{title}}</h2>
    <slot />
  </div>
</template>

<script>
export default {
  name: "Title",
  props: {
    title: {
      type: String,
      defalut: ""
    }
  }
}
</script>

<style lang="scss" scoped>
.title{
  margin: 0 auto;
  width: 1200px;
  line-height: 84px;
  display: flex;
  justify-content: space-between;
  h2{
    color: #343434;
    font-size: 24px;
    font-weight: bold;
  }
}
</style>